import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.from";
import _slicedToArray from "/tmp/sites/visa-claim.airrefund.com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/tmp/sites/visa-claim.airrefund.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/sites/visa-claim.airrefund.com/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Reference from '../Reference';

var ReferenceSet = /*#__PURE__*/function () {
  function ReferenceSet() {
    _classCallCheck(this, ReferenceSet);

    this.list = new Set();
    this.refs = new Map();
  }

  _createClass(ReferenceSet, [{
    key: "describe",
    value: function describe() {
      var description = [];

      var _iterator = _createForOfIteratorHelper(this.list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          description.push(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.refs),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              ref = _step2$value[1];

          description.push(ref.describe());
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return description;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
  }, {
    key: "add",
    value: function add(value) {
      Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      Reference.isRef(value) ? this.refs["delete"](value.key) : this.list["delete"](value);
    }
  }, {
    key: "has",
    value: function has(value, resolve) {
      if (this.list.has(value)) return true;
      var item,
          values = this.refs.values();

      while (item = values.next(), !item.done) {
        if (resolve(item.value) === value) return true;
      }

      return false;
    }
  }, {
    key: "clone",
    value: function clone() {
      var next = new ReferenceSet();
      next.list = new Set(this.list);
      next.refs = new Map(this.refs);
      return next;
    }
  }, {
    key: "merge",
    value: function merge(newItems, removeItems) {
      var next = this.clone();
      newItems.list.forEach(function (value) {
        return next.add(value);
      });
      newItems.refs.forEach(function (value) {
        return next.add(value);
      });
      removeItems.list.forEach(function (value) {
        return next["delete"](value);
      });
      removeItems.refs.forEach(function (value) {
        return next["delete"](value);
      });
      return next;
    }
  }, {
    key: "size",
    get: function get() {
      return this.list.size + this.refs.size;
    }
  }]);

  return ReferenceSet;
}();

export { ReferenceSet as default };